"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAccordion = void 0;
const react_1 = require("react");
const useAccordion = ({ initialOpened = [], singleOpened = false }) => {
    const [openedItems, setOpenedItems] = (0, react_1.useState)(initialOpened);
    const toggleItem = (0, react_1.useCallback)((key) => {
        const isOpened = !!openedItems.find(itemKey => itemKey === key);
        if (isOpened) {
            if (singleOpened) {
                setOpenedItems([]);
            }
            else {
                setOpenedItems(prevState => prevState.filter(itemKey => itemKey !== key));
            }
        }
        else {
            if (singleOpened) {
                setOpenedItems([key]);
            }
            else {
                setOpenedItems(prevState => [...prevState, key]);
            }
        }
    }, [openedItems, singleOpened, setOpenedItems]);
    const closeAll = (0, react_1.useCallback)(() => {
        setOpenedItems([]);
    }, [setOpenedItems]);
    return { openedItems, toggleItem, closeAll };
};
exports.useAccordion = useAccordion;
exports.default = exports.useAccordion;
